var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g2, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g3, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g4, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotCheckedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 71,
    viewBox: "0 0 75 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_4979_804)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21773 5.60589V14.7671L1.75399 18.2406L1.59607 37.0206H73.2987V3.43994H47.7365L44.477 4.84823H5.33144L5.21773 5.60589Z",
    fill: "url(#paint0_linear_4979_804)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 62.884H16.2848L20.355 66.941H57.9382L61.5493 65.3186H73.7619V71.0001H17.9125L16.0132 69.1049H0V62.884Z",
    fill: "#BD2333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8476 68.855H69.5044V58.3527L72.9555 54.9128V45.1051H73.2987V55.0555L69.8476 58.4954V68.855Z",
    fill: "#BD2333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8988 33.9353H72.3553V45.1072H73.8988V33.9353Z",
    fill: "#BD2333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04718 5.71082H5.39039V14.8091L1.93929 18.2469V28.0566H1.59607V18.1063L5.04718 14.6664V5.71082Z",
    fill: "#BD2333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53939 28.0566H0.995972V39.2285H2.53939V28.0566Z",
    fill: "#BD2333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93929 39.2264H1.59607V52.3313H1.93929V39.2264Z",
    fill: "#BD2333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54798 0L1.05493 2.33176H2.8405L5.33144 0H3.54798Z",
    fill: "#BD2333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55076 0L5.05981 2.33176H6.84327L9.33422 0H7.55076Z",
    fill: "#BD2333"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5536 0L9.06262 2.33176H10.8461L13.337 0H11.5536Z",
    fill: "#BD2333"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5563 0L13.0653 2.33176H14.8488L17.3418 0H15.5563Z",
    fill: "#BD2333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5591 0L17.0681 2.33176H18.8537L21.3446 0H19.5591Z",
    fill: "#BD2333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5639 0L21.073 2.33176H22.8565L25.3474 0H23.5639Z",
    fill: "#BD2333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5668 0L25.0758 2.33176H26.8593L29.3502 0H27.5668Z",
    fill: "#BD2333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5696 0L29.0786 2.33176H30.8621L33.353 0H31.5696Z",
    fill: "#BD2333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5722 0L33.0813 2.33176H34.8669L37.3578 0H35.5722Z",
    fill: "#BD2333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5772 0L37.0863 2.33176H38.8698L41.3607 0H39.5772Z",
    fill: "#BD2333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5799 0L41.089 2.33176H42.8724L45.3634 0H43.5799Z",
    fill: "#BD2333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1281 4.32768V20.4317L75 22.2996V2.28556H69.6917L67.464 0.0671387H49.8568L45.2939 4.61522L73.1281 4.32768Z",
    fill: "#BD2333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9698 4.32776H0.907471V6.49161H45.9698V4.32776Z",
    fill: "#BD2333"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4979_804)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7286 58.9073V56.0342H11.274V58.9073C11.274 58.9248 11.274 58.9437 11.274 58.9625C11.274 61.6728 24.047 61.7509 25.5034 61.7509C26.9599 61.7509 39.7328 61.6728 39.7328 58.9625C39.7328 58.9437 39.73 58.9248 39.7286 58.9073Z",
    fill: "#FFBB45"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7328 58.9626C39.5589 61.6177 26.9501 61.7509 25.5034 61.7509C24.0567 61.7509 11.4535 61.5867 11.274 58.9316C11.274 58.9316 11.274 59.1928 11.274 59.2117C11.274 61.9219 24.047 62 25.5034 62C26.9599 62 39.7328 61.9219 39.7328 59.2117V58.9626Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4979_804",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 56,
    width: 29,
    height: 6
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7286 58.9073V56.0342H11.274V58.9073C11.274 58.9248 11.274 58.9437 11.274 58.9625C11.274 61.6728 24.047 61.7509 25.5034 61.7509C26.9599 61.7509 39.7328 61.6728 39.7328 58.9625C39.7328 58.9437 39.73 58.9248 39.7286 58.9073Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4979_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.441 56.2631H11V61.9905H11.441V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4578 56.2631H12.0168V61.9905H12.4578V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4748 56.2631H13.0338V61.9905H13.4748V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4916 56.2631H14.0507V61.9905H14.4916V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5085 56.2631H15.0675V61.9905H15.5085V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5253 56.2631H16.0844V61.9905H16.5253V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5423 56.2631H17.1013V61.9905H17.5423V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5591 56.2631H18.1182V61.9905H18.5591V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.576 56.2631H19.135V61.9905H19.576V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5929 56.2631H20.152V61.9905H20.5929V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6083 56.2631H21.1674V61.9905H21.6083V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6253 56.2631H22.1843V61.9905H22.6253V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6421 56.2631H23.2012V61.9905H23.6421V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.659 56.2631H24.218V61.9905H24.659V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.676 56.2631H25.235V61.9905H25.676V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6928 56.2631H26.2518V61.9905H26.6928V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7097 56.2631H27.2687V61.9905H27.7097V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7265 56.2631H28.2855V61.9905H28.7265V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7435 56.2631H29.3025V61.9905H29.7435V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7603 56.2631H30.3193V61.9905H30.7603V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7772 56.2631H31.3362V61.9905H31.7772V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7941 56.2631H32.3531V61.9905H32.7941V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.811 56.2631H33.37V61.9905H33.811V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8278 56.2631H34.3868V61.9905H34.8278V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8447 56.2631H35.4037V61.9905H35.8447V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8616 56.2631H36.4207V61.9905H36.8616V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8785 56.2631H37.4375V61.9905H37.8785V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8953 56.2631H38.4543V61.9905H38.8953V56.2631Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9108 56.2631H39.4698V61.9905H39.9108V56.2631Z",
    fill: "#E3931B"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5034 58.7835C33.3621 58.7835 39.7328 57.6762 39.7328 56.3102C39.7328 54.9442 33.3621 53.8369 25.5034 53.8369C17.6448 53.8369 11.274 54.9442 11.274 56.3102C11.274 57.6762 17.6448 58.7835 25.5034 58.7835Z",
    fill: "#E3931B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5034 58.5142C33.3621 58.5142 39.7328 57.4069 39.7328 56.0409C39.7328 54.675 33.3621 53.5676 25.5034 53.5676C17.6448 53.5676 11.274 54.675 11.274 56.0409C11.274 57.4069 17.6448 58.5142 25.5034 58.5142Z",
    fill: "#FFE669"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5034 57.7064C32.4186 57.7064 38.0245 56.9608 38.0245 56.041C38.0245 55.1211 32.4186 54.3755 25.5034 54.3755C18.5882 54.3755 12.9823 55.1211 12.9823 56.041C12.9823 56.9608 18.5882 57.7064 25.5034 57.7064Z",
    fill: "#FFBB45"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5034 57.7064C32.4186 57.7064 38.0245 56.9608 38.0245 56.041C38.0245 55.1211 32.4186 54.3755 25.5034 54.3755C18.5882 54.3755 12.9823 55.1211 12.9823 56.041C12.9823 56.9608 18.5882 57.7064 25.5034 57.7064Z",
    fill: "#FFBB45"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5034 54.6596C32.0596 54.6596 37.4389 55.3327 37.98 56.1823C38.007 56.1421 38.0224 56.0956 38.0246 56.0477C38.0246 55.1281 32.4185 54.3822 25.5048 54.3822C18.5912 54.3822 12.9851 55.1281 12.9851 56.0477C12.9877 56.0957 13.0036 56.1422 13.031 56.1823C13.5694 55.3287 18.9473 54.6596 25.5034 54.6596Z",
    fill: "#D98A14"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6826 57.285V57.1261C23.3138 57.1261 22.1648 57.0884 21.2662 57.0318C20.1269 56.9591 19.5496 56.8528 19.5496 56.7168V56.6912H22.0396V56.7168C22.0396 56.7922 22.3053 56.8514 22.8506 56.8784C23.2262 56.9026 23.8424 56.9201 24.6826 56.9309V56.4071L24.1165 56.3869C22.8534 56.3411 21.913 56.2886 21.319 56.2334C20.5303 56.1594 20.131 56.0651 20.131 55.952C20.131 55.7003 21.6612 55.5481 24.6826 55.5145V55.3502H26.6677V55.5131C27.6943 55.5131 28.5791 55.5428 29.2955 55.5858C30.2372 55.6437 30.7144 55.7205 30.7144 55.8322V55.8578H28.2355V55.8322C28.2355 55.7676 27.7222 55.7259 26.6677 55.707V56.2375L27.4773 56.2644C29.9034 56.3452 31.1345 56.4798 31.1345 56.6683C31.1345 56.803 30.6726 56.9066 29.7629 56.9914C28.9463 57.0668 27.9058 57.114 26.6677 57.1261V57.2863L24.6826 57.285ZM26.6677 56.9255C27.2826 56.916 27.7806 56.8918 28.1367 56.8541C28.5304 56.8137 28.7293 56.7585 28.7293 56.6912C28.7293 56.6239 28.5053 56.5821 28.0435 56.5445C27.7542 56.5216 27.2909 56.4987 26.6677 56.4758V56.9255ZM24.6826 55.7043C23.2373 55.7339 22.5418 55.812 22.5418 55.9467C22.5418 56.0072 22.7769 56.0557 23.2596 56.0948C23.5517 56.1177 24.0316 56.1432 24.6896 56.1675L24.6826 55.7043Z",
    fill: "#D98A14"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6826 56.9511V56.7922C23.3138 56.7922 22.1648 56.7545 21.2662 56.698C20.1269 56.6253 19.5496 56.5189 19.5496 56.3829V56.3573H22.0396V56.3829C22.0396 56.4583 22.3053 56.5108 22.8506 56.5445C23.2262 56.5687 23.8424 56.5862 24.6826 56.597V56.0733L24.1165 56.0598C22.8534 56.0127 21.913 55.9615 21.319 55.9063C20.5303 55.8323 20.131 55.738 20.131 55.6236C20.131 55.3731 21.6612 55.2264 24.6826 55.1873V55.0164H26.6677V55.1793C27.6943 55.1793 28.5791 55.2089 29.2955 55.252C30.2372 55.3099 30.7144 55.3866 30.7144 55.4984V55.5212H28.2355V55.497C28.2355 55.431 27.7222 55.3906 26.6677 55.3718V55.9023L27.4773 55.9292C29.9034 56.01 31.1345 56.1446 31.1345 56.3331C31.1345 56.4677 30.6726 56.5714 29.7629 56.6562C28.9463 56.7316 27.9058 56.7788 26.6677 56.7909V56.9511H24.6826ZM26.6677 56.5983C27.2826 56.5876 27.7806 56.5647 28.1367 56.527C28.5304 56.4852 28.7293 56.4314 28.7293 56.3641C28.7293 56.2968 28.5053 56.255 28.0435 56.2173C27.7542 56.1944 27.2909 56.1715 26.6677 56.1487V56.5983ZM24.6826 55.3705C23.2373 55.3987 22.5418 55.4782 22.5418 55.6128C22.5418 55.6734 22.7769 55.7219 23.2596 55.7609C23.5517 55.7838 24.0316 55.808 24.6896 55.8336L24.6826 55.3705Z",
    fill: "#FFE669"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8177 58.7364V55.8633H34.366V58.7364C34.366 58.7539 34.366 58.7728 34.366 58.7916C34.366 61.5019 47.1361 61.58 48.5925 61.58C50.049 61.58 62.8219 61.5019 62.8219 58.7916C62.8219 58.7728 62.8191 58.7526 62.8177 58.7364Z",
    fill: "#FFBB45"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.822 58.7916C62.6481 61.4453 50.0394 61.5799 48.5926 61.5799C47.1459 61.5799 34.5427 61.4157 34.3674 58.7526C34.3674 58.7526 34.3674 59.0218 34.3674 59.034C34.3674 61.7442 47.1403 61.8223 48.5968 61.8223C50.0533 61.8223 62.8262 61.7442 62.8262 59.034L62.822 58.7916Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4979_804",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 55,
    width: 29,
    height: 7
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8177 58.7364V55.8633H34.366V58.7364C34.366 58.7539 34.366 58.7728 34.366 58.7916C34.366 61.5019 47.1361 61.58 48.5925 61.58C50.049 61.58 62.8219 61.5019 62.8219 58.7916C62.8219 58.7728 62.8191 58.7526 62.8177 58.7364Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4979_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5301 56.0922H34.0891V61.8196H34.5301V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5456 56.0922H35.1046V61.8196H35.5456V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5624 56.0922H36.1215V61.8196H36.5624V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5793 56.0922H37.1383V61.8196H37.5793V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5962 56.0922H38.1553V61.8196H38.5962V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6131 56.0922H39.1721V61.8196H39.6131V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6299 56.0922H40.189V61.8196H40.6299V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6469 56.0922H41.2059V61.8196H41.6469V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6638 56.0922H42.2228V61.8196H42.6638V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6806 56.0922H43.2396V61.8196H43.6806V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6974 56.0922H44.2565V61.8196H44.6974V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7144 56.0922H45.2734V61.8196H45.7144V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7313 56.0922H46.2903V61.8196H46.7313V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7481 56.0922H47.3071V61.8196H47.7481V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7651 56.0922H48.3241V61.8196H48.7651V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7819 56.0922H49.3409V61.8196H49.7819V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7988 56.0922H50.3578V61.8196H50.7988V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8156 56.0922H51.3746V61.8196H51.8156V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8326 56.0922H52.3916V61.8196H52.8326V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8481 56.0922H53.4071V61.8196H53.8481V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8649 56.0922H54.424V61.8196H54.8649V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8818 56.0922H55.4408V61.8196H55.8818V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8986 56.0922H56.4576V61.8196H56.8986V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9156 56.0922H57.4746V61.8196H57.9156V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9324 56.0922H58.4915V61.8196H58.9324V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9493 56.0922H59.5083V61.8196H59.9493V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9662 56.0922H60.5253V61.8196H60.9662V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9831 56.0922H61.5421V61.8196H61.9831V56.0922Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9999 56.0922H62.559V61.8196H62.9999V56.0922Z",
    fill: "#E3931B"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5912 58.6126C56.4498 58.6126 62.8206 57.5053 62.8206 56.1393C62.8206 54.7733 56.4498 53.666 48.5912 53.666C40.7325 53.666 34.3618 54.7733 34.3618 56.1393C34.3618 57.5053 40.7325 58.6126 48.5912 58.6126Z",
    fill: "#E3931B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5912 58.3433C56.4498 58.3433 62.8206 57.236 62.8206 55.87C62.8206 54.5041 56.4498 53.3967 48.5912 53.3967C40.7325 53.3967 34.3618 54.5041 34.3618 55.87C34.3618 57.236 40.7325 58.3433 48.5912 58.3433Z",
    fill: "#FFE669"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5912 57.5354C55.5064 57.5354 61.1123 56.7897 61.1123 55.8699C61.1123 54.9501 55.5064 54.2045 48.5912 54.2045C41.676 54.2045 36.0701 54.9501 36.0701 55.8699C36.0701 56.7897 41.676 57.5354 48.5912 57.5354Z",
    fill: "#FFBB45"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5912 57.5354C55.5064 57.5354 61.1123 56.7897 61.1123 55.8699C61.1123 54.9501 55.5064 54.2045 48.5912 54.2045C41.676 54.2045 36.0701 54.9501 36.0701 55.8699C36.0701 56.7897 41.676 57.5354 48.5912 57.5354Z",
    fill: "#FFBB45"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5926 54.4872C55.1487 54.4872 60.5266 55.1604 61.0678 56.0113C61.0952 55.9712 61.1111 55.9247 61.1137 55.8766C61.1137 54.9557 55.5076 54.2112 48.5939 54.2112C41.6803 54.2112 36.0742 54.9557 36.0742 55.8766C36.0768 55.9247 36.0927 55.9712 36.1201 56.0113C36.6571 55.1577 42.0364 54.4872 48.5926 54.4872Z",
    fill: "#D98A14"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7718 57.1141V56.9538C46.4016 56.9538 45.254 56.9175 44.3553 56.8609C43.216 56.7882 42.6373 56.6819 42.6373 56.5445V56.5203H45.1288V56.5445C45.1288 56.6213 45.3931 56.6792 45.9384 56.7075C46.3153 56.7317 46.9302 56.7478 47.7718 56.7586V56.2362L47.2056 56.216C45.9425 56.1689 45.0008 56.1177 44.4068 56.0625C43.6194 55.9885 43.2188 55.8942 43.2188 55.7798C43.2188 55.5294 44.749 55.3759 47.7718 55.3436V55.1793H49.7555V55.3422C50.7835 55.3422 51.6668 55.3719 52.3846 55.4149C53.3264 55.4715 53.8035 55.5496 53.8035 55.6613V55.6856H51.3232V55.6559C51.3232 55.59 50.8099 55.5496 49.7555 55.5294V56.0679L50.5651 56.0949C52.9925 56.1756 54.2222 56.3103 54.2222 56.4988C54.2222 56.6334 53.7618 56.7357 52.852 56.8219C52.0355 56.8973 50.9949 56.9444 49.7555 56.9565V57.1168L47.7718 57.1141ZM49.7555 56.7532C50.3703 56.7438 50.8684 56.7209 51.2245 56.6832C51.6181 56.6415 51.8185 56.5876 51.8185 56.519C51.8185 56.4503 51.5945 56.4099 51.1327 56.3736C50.8419 56.3507 50.3801 56.3278 49.7555 56.3049V56.7532ZM47.7718 55.5334C46.3265 55.5617 45.6226 55.6411 45.6226 55.7758C45.6226 55.8364 45.8577 55.8848 46.3418 55.9225C46.6339 55.9468 47.1138 55.971 47.7718 55.9966V55.5334Z",
    fill: "#D98A14"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7718 56.7787V56.6198C46.4016 56.6198 45.254 56.5835 44.3553 56.5256C43.216 56.4542 42.6373 56.3479 42.6373 56.2106V56.1863H45.1288V56.2106C45.1288 56.2873 45.3931 56.3452 45.9384 56.3735C46.3153 56.3964 46.9302 56.4139 47.7718 56.4246V55.9022L47.2056 55.882C45.9425 55.8349 45.0008 55.7838 44.4068 55.7272C43.6194 55.6545 43.2188 55.5589 43.2188 55.4458C43.2188 55.1954 44.749 55.0419 47.7718 55.0096V54.848H49.7555V55.0109C50.7835 55.0109 51.6668 55.0406 52.3846 55.0836C53.3264 55.1402 53.8035 55.2183 53.8035 55.3287V55.3543H51.3232V55.3287C51.3232 55.2641 50.8099 55.2237 49.7555 55.2035V55.7353L50.5651 55.7622C52.9925 55.843 54.2222 55.9776 54.2222 56.1661C54.2222 56.3008 53.7618 56.4031 52.852 56.4879C52.0355 56.5646 50.9949 56.6118 49.7555 56.6225V56.7828L47.7718 56.7787ZM49.7555 56.4192C50.3703 56.4098 50.8684 56.3856 51.2245 56.3492C51.6181 56.3075 51.8185 56.2523 51.8185 56.185C51.8185 56.1177 51.5945 56.0759 51.1327 56.0396C50.8419 56.0167 50.3801 55.9924 49.7555 55.9709V56.4192ZM47.7718 55.1994C46.3265 55.2277 45.6226 55.3071 45.6226 55.4404C45.6226 55.5024 45.8577 55.5508 46.3418 55.5885C46.6339 55.6128 47.1138 55.637 47.7718 55.6626V55.1994Z",
    fill: "#FFE669"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9793 54.5142L49.1448 51.6464L20.7334 50.1129L20.5678 52.9807C20.5678 52.9995 20.5678 53.017 20.5678 53.0359C20.412 55.7421 33.1613 56.5082 34.6177 56.5876C36.0742 56.6671 48.8304 57.277 48.9862 54.5681C48.982 54.5519 48.9793 54.5331 48.9793 54.5142Z",
    fill: "#FFBB45"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9807 54.5707C48.6538 57.2123 36.0562 56.6657 34.6123 56.5903C33.1683 56.5149 20.5943 55.6653 20.5721 53.0049L20.5512 53.2849C20.3954 55.9911 33.1433 56.7572 34.6011 56.8367C36.059 56.9161 48.8124 57.5247 48.9682 54.8171C48.9724 54.8009 48.9807 54.5707 48.9807 54.5707Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4979_804",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 50,
    width: 30,
    height: 7
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9793 54.5142L49.1448 51.6464L20.7334 50.1129L20.5678 52.9807C20.5678 52.9995 20.5678 53.017 20.5678 53.0359C20.412 55.7421 33.1613 56.5082 34.6177 56.5876C36.0742 56.6671 48.8304 57.277 48.9862 54.5681C48.982 54.5519 48.9793 54.5331 48.9793 54.5142Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4979_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.447 50.3246L20.1177 56.0432L20.558 56.067L20.8873 50.3484L20.447 50.3246Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4604 50.3803L21.1311 56.0989L21.5714 56.1226L21.9007 50.404L21.4604 50.3803Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4766 50.4347L22.1473 56.1533L22.5876 56.1771L22.9169 50.4585L22.4766 50.4347Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4915 50.489L23.1622 56.2076L23.6025 56.2314L23.9318 50.5128L23.4915 50.489Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5078 50.5435L24.1785 56.2621L24.6188 56.2858L24.9481 50.5672L24.5078 50.5435Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5213 50.5978L25.192 56.3164L25.6323 56.3402L25.9616 50.6216L25.5213 50.5978Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5405 50.6556L26.2102 56.3741L26.6505 56.398L26.9808 50.6794L26.5405 50.6556Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5523 50.708L27.223 56.4266L27.6633 56.4504L27.9926 50.7318L27.5523 50.708Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5686 50.7637L28.2393 56.4823L28.6795 56.5061L29.0088 50.7875L28.5686 50.7637Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5857 50.8188L29.2554 56.5374L29.6957 56.5612L30.026 50.8426L29.5857 50.8188Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5983 50.8725L30.269 56.5911L30.7093 56.6148L31.0386 50.8962L30.5983 50.8725Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6132 50.9269L31.2839 56.6455L31.7242 56.6693L32.0535 50.9507L31.6132 50.9269Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6307 50.9847L32.3004 56.7032L32.7407 56.7271L33.071 51.0085L32.6307 50.9847Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6429 51.037L33.3136 56.7556L33.7539 56.7794L34.0832 51.0608L33.6429 51.037Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6591 51.0915L34.3298 56.8101L34.7701 56.8338L35.0994 51.1152L34.6591 51.0915Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.674 51.1458L35.3447 56.8644L35.785 56.8881L36.1143 51.1695L35.674 51.1458Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6889 51.2015L36.3596 56.92L36.7999 56.9438L37.1292 51.2252L36.6889 51.2015Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7037 51.2572L37.3744 56.9758L37.8147 56.9996L38.144 51.281L37.7037 51.2572Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.72 51.3117L38.3907 57.0303L38.831 57.054L39.1603 51.3354L38.72 51.3117Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7389 51.3683L39.4086 57.0868L39.8489 57.1106L40.1792 51.3921L39.7389 51.3683Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7497 51.4204L40.4204 57.139L40.8607 57.1628L41.19 51.4442L40.7497 51.4204Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7646 51.4748L41.4353 57.1934L41.8756 57.2171L42.2049 51.4985L41.7646 51.4748Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7853 51.5328L42.455 57.2513L42.8952 57.2752L43.2256 51.5566L42.7853 51.5328Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7943 51.5862L43.465 57.3048L43.9053 57.3286L44.2346 51.61L43.7943 51.5862Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8106 51.6407L44.4813 57.3593L44.9216 57.383L45.2509 51.6644L44.8106 51.6407Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8319 51.696L45.5016 57.4146L45.9419 57.4384L46.2722 51.7198L45.8319 51.696Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8418 51.7495L46.5125 57.4681L46.9527 57.4919L47.282 51.7733L46.8418 51.7495Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8552 51.8052L47.5259 57.5238L47.9662 57.5476L48.2955 51.829L47.8552 51.8052Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8714 51.8595L48.5421 57.5781L48.9824 57.6019L49.3117 51.8833L48.8714 51.8595Z",
    fill: "#E3931B"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7833 53.6242C33.3296 53.5461 20.5789 52.7867 20.718 50.3929C20.8572 47.999 33.6134 48.6116 35.0684 48.6911C36.5235 48.7705 49.2714 49.5272 49.1337 51.9224C48.9959 54.3176 36.2369 53.7023 34.7833 53.6242Z",
    fill: "#E3931B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7986 53.3549C33.345 53.2768 20.5943 52.5188 20.7334 50.1182C20.8725 47.7177 33.6288 48.3383 35.0838 48.4164C36.5389 48.4945 49.2868 49.2525 49.149 51.6477C49.0113 54.0429 36.2537 53.433 34.7986 53.3549Z",
    fill: "#FFE669"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4404 51.5605C47.4933 50.6421 41.9389 49.5957 35.0344 49.2232C28.1299 48.8508 22.4898 49.2934 22.4369 50.2118C22.3841 51.1301 27.9384 52.1766 34.8429 52.549C41.7474 52.9215 47.3875 52.4789 47.4404 51.5605Z",
    fill: "#FFBB45"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4404 51.5605C47.4933 50.6421 41.9389 49.5957 35.0344 49.2232C28.1299 48.8508 22.4898 49.2934 22.4369 50.2118C22.3841 51.1301 27.9384 52.1766 34.8429 52.549C41.7474 52.9215 47.3875 52.4789 47.4404 51.5605Z",
    fill: "#FFBB45"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0211 49.5057C41.5592 49.8598 46.8982 50.8184 47.3892 51.7003C47.4193 51.6608 47.438 51.6143 47.4435 51.5656C47.4964 50.6474 41.9418 49.5999 35.0364 49.227C28.1311 48.854 22.4917 49.297 22.4388 50.2152C22.4375 50.2656 22.4505 50.3155 22.4764 50.3593C23.0662 49.5312 28.4747 49.1529 35.0211 49.5057Z",
    fill: "#D98A14"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0502 52.084L34.06 51.9251C32.6967 51.8457 31.5477 51.7515 30.6532 51.6465C29.5195 51.5118 28.9491 51.3772 28.9575 51.2425V51.2129L31.4447 51.3476V51.3718C31.4447 51.4485 31.7021 51.5159 32.2446 51.5778C32.6188 51.6222 33.2323 51.672 34.0725 51.7286L34.1017 51.2062L33.5314 51.1564C32.2794 51.0419 31.3348 50.9396 30.7492 50.8521C29.9674 50.7363 29.5737 50.6205 29.5793 50.5074C29.5946 50.257 31.1317 50.1924 34.1504 50.3162L34.1601 50.152L36.141 50.2597L36.1327 50.4226C37.1579 50.4818 38.0385 50.5572 38.7521 50.6367C39.6883 50.7444 40.1613 50.8521 40.1543 50.9585V50.984L37.6782 50.8494V50.8252C37.6782 50.7605 37.1718 50.6905 36.1216 50.6151L36.091 51.1456L36.8978 51.2156C39.3155 51.427 40.5368 51.6276 40.5257 51.8107C40.5257 51.9453 40.0514 52.0234 39.1346 52.0598C38.3139 52.0908 37.272 52.0813 36.0353 52.0302V52.1904L34.0502 52.084ZM36.052 51.8322C36.6669 51.8551 37.1649 51.8578 37.5224 51.8403C37.9188 51.8201 38.1205 51.7757 38.1247 51.7057C38.1289 51.6357 37.9077 51.5859 37.4486 51.5239C37.1593 51.4849 36.7002 51.4364 36.0784 51.3812L36.052 51.8322ZM34.1407 50.5061C32.6967 50.4563 31.99 50.498 31.9817 50.6313C31.9817 50.6932 32.2098 50.7538 32.6911 50.8184C32.9805 50.8575 33.459 50.9073 34.1142 50.9679L34.1407 50.5061Z",
    fill: "#D98A14"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0696 51.7514L34.078 51.5925C32.7119 51.5131 31.5657 51.4202 30.6726 51.3138C29.5389 51.1792 28.9686 51.0445 28.9769 50.9099V50.8843L31.4628 51.0189V51.0445C31.4628 51.1199 31.7201 51.1872 32.2626 51.2492C32.6368 51.2936 33.2503 51.3448 34.0891 51.4L34.1197 50.8789L33.5633 50.8264C32.3044 50.7133 31.3668 50.611 30.7811 50.5221C29.9993 50.4063 29.6057 50.2906 29.6112 50.1775C29.6265 49.927 31.1637 49.8638 34.1823 49.9876L34.1921 49.8234L36.173 49.9297L36.1646 50.0926C37.1898 50.1532 38.0704 50.2273 38.784 50.3067C39.7202 50.4144 40.1918 50.5235 40.1862 50.6285V50.6541L37.7101 50.5194V50.4939C37.7101 50.4292 37.2038 50.3592 36.1535 50.2838L36.1118 50.8089L36.9172 50.8789C39.3363 51.0916 40.5563 51.2909 40.5465 51.474C40.5382 51.6087 40.0722 51.6867 39.1554 51.7231C38.3361 51.7554 37.2942 51.7446 36.0575 51.6948L36.0478 51.8537L34.0696 51.7514ZM36.0714 51.4996C36.6849 51.5225 37.1843 51.5252 37.5418 51.5077C37.9382 51.4875 38.1399 51.4444 38.1441 51.373C38.1483 51.3017 37.9257 51.2519 37.4667 51.1899C37.1787 51.1509 36.7197 51.1024 36.0978 51.0472L36.0714 51.4996ZM34.1601 50.1734C32.7161 50.125 32.0095 50.1653 32.0011 50.2986C32.0011 50.3606 32.2292 50.4212 32.7092 50.4858C32.9999 50.5248 33.4784 50.576 34.1336 50.6366L34.1601 50.1734Z",
    fill: "#FFE669"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9875 48.3263V45.4531L27.5358 45.4801V48.3532C27.5358 48.3721 27.5358 48.3896 27.5358 48.4084C27.5358 51.1187 40.3115 51.1846 41.7679 51.1833C43.2244 51.1819 55.9945 51.0917 55.9917 48.3855C55.9917 48.3626 55.9889 48.3451 55.9875 48.3263Z",
    fill: "#FFBB45"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9918 48.3855C55.8207 51.0406 43.2119 51.186 41.7652 51.1873C40.3185 51.1887 27.7153 51.0365 27.5372 48.3815C27.5372 48.3815 27.5372 48.6427 27.5372 48.6615C27.5372 51.3718 40.3129 51.4377 41.7694 51.4364C43.2258 51.435 55.9946 51.3475 55.9918 48.6305V48.3855Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4979_804",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 45,
    width: 29,
    height: 7
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9875 48.3263V45.4531L27.5358 45.4801V48.3532C27.5358 48.3721 27.5358 48.3896 27.5358 48.4084C27.5358 51.1187 40.3115 51.1846 41.7679 51.1833C43.2244 51.1819 55.9945 51.0917 55.9917 48.3855C55.9917 48.3626 55.9889 48.3451 55.9875 48.3263Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4979_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6999 45.709H27.2589V51.4365H27.6999V45.709Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7167 45.7076H28.2758V51.4351H28.7167V45.7076Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7281 45.7251H29.2871V51.4526H29.7281V45.7251Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7491 45.7063H30.3081V51.4338H30.7491V45.7063Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.766 45.705H31.3251V51.4324H31.766V45.705Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7829 45.7035H32.3419V51.431H32.7829V45.7035Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7997 45.7035H33.3588V51.431H33.7997V45.7035Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8167 45.7021H34.3757V51.4296H34.8167V45.7021Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8336 45.7008H35.3926V51.4283H35.8336V45.7008Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8504 45.7008H36.4094V51.4283H36.8504V45.7008Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8672 45.6995H37.4263V51.4269H37.8672V45.6995Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8842 45.6981H38.4432V51.4256H38.8842V45.6981Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9011 45.6968H39.4601V51.4242H39.9011V45.6968Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9179 45.6968H40.4769V51.4242H40.9179V45.6968Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9349 45.6954H41.4939V51.4229H41.9349V45.6954Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9517 45.6941H42.5107V51.4216H42.9517V45.6941Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9686 45.6941H43.5276V51.4216H43.9686V45.6941Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9854 45.6927H44.5444V51.4202H44.9854V45.6927Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0024 45.6914H45.5614V51.4189H46.0024V45.6914Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0192 45.6901H46.5782V51.4175H47.0192V45.6901Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0361 45.6901H47.5951V51.4175H48.0361V45.6901Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.053 45.6887H48.6121V51.4162H49.053V45.6887Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0684 45.6874H49.6274V51.4148H50.0684V45.6874Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0854 45.6874H50.6444V51.4148H51.0854V45.6874Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1022 45.6862H51.6613V51.4136H52.1022V45.6862Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1179 45.6826L52.6769 45.6831L52.6829 51.4106L53.1239 51.4101L53.1179 45.6826Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.136 45.6833H53.6951V51.4108H54.136V45.6833Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1529 45.6833H54.7119V51.4108H55.1529V45.6833Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1697 45.682H55.7288V51.4095H56.1697V45.682Z",
    fill: "#E3931B"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7624 48.2159C40.306 48.2159 27.5317 48.1593 27.5303 45.756C27.5289 43.3528 40.3004 43.2693 41.7569 43.2693C43.2133 43.2693 55.9862 43.3258 55.989 45.7291C55.9918 48.1324 43.2189 48.2145 41.7624 48.2159Z",
    fill: "#E3931B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M41.761 47.9466C40.3045 47.9466 27.5316 47.89 27.5288 45.4867C27.526 43.0835 40.3003 43 41.7568 43C43.2132 43 55.9862 43.0565 55.9889 45.4598C55.9917 47.8631 43.2174 47.9452 41.761 47.9466Z",
    fill: "#FFE669"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7582 47.1388C48.6734 47.1388 54.2793 46.3931 54.2793 45.4733C54.2793 44.5535 48.6734 43.8079 41.7582 43.8079C34.843 43.8079 29.2371 44.5535 29.2371 45.4733C29.2371 46.3931 34.843 47.1388 41.7582 47.1388Z",
    fill: "#FFBB45"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7582 47.1388C48.6734 47.1388 54.2793 46.3931 54.2793 45.4733C54.2793 44.5535 48.6734 43.8079 41.7582 43.8079C34.843 43.8079 29.2371 44.5535 29.2371 45.4733C29.2371 46.3931 34.843 47.1388 41.7582 47.1388Z",
    fill: "#FFBB45"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7582 44.0919C48.3143 44.0919 53.6936 44.7502 54.2348 45.6025C54.2622 45.5624 54.2781 45.5159 54.2807 45.4678C54.2807 44.5483 48.6732 43.8078 41.7609 43.8145C34.8487 43.8212 29.2412 44.5725 29.2412 45.4921C29.2426 45.5424 29.2585 45.5914 29.2871 45.6334C29.8241 44.7731 35.2006 44.0972 41.7582 44.0919Z",
    fill: "#D98A14"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9403 46.7173V46.5585C39.57 46.5585 38.421 46.5248 37.5224 46.4682C36.3831 46.3969 35.8058 46.2919 35.8058 46.1545V46.129H38.2958V46.1545C38.2958 46.2299 38.5615 46.2892 39.1068 46.3161C39.4824 46.339 40.0987 46.3565 40.9389 46.3659V45.8408L40.3727 45.8274C39.1096 45.7829 38.1678 45.7318 37.5738 45.6766C36.7865 45.6039 36.3859 45.5096 36.3859 45.3952C36.3859 45.1448 37.9161 44.9913 40.9375 44.9549V44.7839H42.9226V44.9468C43.9492 44.9468 44.8339 44.9738 45.5503 45.0169C46.4921 45.0721 46.9692 45.1515 46.9692 45.2606V45.2888H44.4903V45.2619C44.4903 45.1973 43.977 45.1569 42.9226 45.138V45.6685L43.7308 45.6954C46.1582 45.7735 47.3893 45.9068 47.3893 46.0899C47.3893 46.2246 46.9275 46.3282 46.0177 46.4144C45.2011 46.4911 44.1606 46.5383 42.9226 46.5558V46.716L40.9403 46.7173ZM42.9239 46.3565C43.5388 46.3457 44.0368 46.3215 44.3929 46.2838C44.7866 46.2421 44.9855 46.1882 44.9855 46.1209C44.9855 46.0536 44.7616 46.0118 44.2997 45.9755C44.009 45.9512 43.5472 45.9297 42.9239 45.9068V46.3565ZM40.9389 45.1448C39.4935 45.1744 38.7897 45.2552 38.7897 45.3885C38.7897 45.4504 39.0247 45.4975 39.5088 45.5352C39.801 45.5594 40.2809 45.5837 40.9389 45.6079V45.1448Z",
    fill: "#D98A14"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9388 46.3835V46.2313C39.57 46.2313 38.4209 46.1977 37.5223 46.1411C36.383 46.063 35.8057 45.962 35.8043 45.8274V45.8018H38.2957V45.8274C38.2957 45.9028 38.5601 45.962 39.1054 45.989C39.4823 46.0119 40.0986 46.0294 40.9388 46.0388V45.507L40.3726 45.4868C39.1095 45.441 38.1678 45.3912 37.5738 45.336C36.785 45.2633 36.3858 45.169 36.3858 45.0546C36.3858 44.8042 37.916 44.6507 40.9374 44.6143V44.4501H42.9225V44.6157C43.9491 44.6157 44.8324 44.6426 45.5502 44.6843C46.492 44.7409 46.9691 44.819 46.9691 44.9294V44.955H44.4902V44.9307C44.4902 44.8661 43.9769 44.8244 42.9225 44.8069V45.3373L43.7321 45.3643C46.1595 45.4423 47.3892 45.5756 47.3892 45.7587C47.3892 45.8934 46.9288 45.9971 46.019 46.0832C45.2025 46.16 44.1619 46.2071 42.9239 46.2246V46.3848L40.9388 46.3835ZM42.9239 46.0226C43.5373 46.0119 44.0367 45.9876 44.3929 45.9499C44.7865 45.9082 44.9855 45.853 44.9855 45.7857C44.9855 45.7184 44.7615 45.6766 44.2997 45.6403C44.0089 45.6174 43.5471 45.5945 42.9225 45.5729L42.9239 46.0226ZM40.9374 44.8109C39.4921 44.8405 38.7896 44.92 38.7896 45.0546C38.7896 45.1152 39.0247 45.1637 39.5074 45.2013C39.7995 45.2256 40.2808 45.2498 40.9388 45.2741L40.9374 44.8109Z",
    fill: "#FFE669"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 25C33.8206 25 30.8596 27.7391 30.8596 31.1298V33.5908C29.8328 33.5908 29 34.3326 29 35.247V44.3438C29 45.2583 29.8328 46 30.8596 46H44.1404C45.1672 46 46 45.2583 46 44.3438V35.247C46 34.3326 45.1672 33.5908 44.1404 33.5908V31.1298C44.1404 27.7389 41.1794 25 37.5 25ZM37.5 27.379C39.855 27.379 41.7495 29.0567 41.7495 31.1446V33.5831L33.2505 33.5839V31.1446C33.2505 29.0567 35.145 27.379 37.5 27.379ZM37.5 36.6935C38.5267 36.6935 39.3596 37.4413 39.3596 38.3644C39.3596 38.9507 39.0222 39.4679 38.5132 39.7667C38.5413 39.8522 38.5626 39.9411 38.5626 40.0353V41.9444C38.5626 42.4729 38.0885 42.8986 37.5 42.8986C36.9115 42.8986 36.4374 42.4729 36.4374 41.9444V40.0353C36.4374 39.942 36.4597 39.8522 36.4868 39.7667C35.9778 39.4688 35.6404 38.9516 35.6404 38.3644C35.6404 37.4422 36.4733 36.6935 37.5 36.6935Z",
    fill: "#BF202F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4979_804",
    x1: 37.4484,
    y1: -0.245536,
    x2: 37.4484,
    y2: 30.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26253F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4979_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 71,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4979_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 19,
    fill: "white",
    transform: "translate(11 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotCheckedIn);
export default __webpack_public_path__ + "static/media/iconNotCheckedIn.54f6b50cbc3ec6863f80c8c0ee7306c6.svg";
export { ForwardRef as ReactComponent };